import { Directive, inject, Injectable } from '@angular/core';
import { Nullable } from '@core/helpers/nullable';
import { TuiDay, TuiValueTransformer } from '@taiga-ui/cdk';
import { tuiInputDateOptionsProvider } from '@taiga-ui/kit';

type From = Nullable<TuiDay>;
type To = Nullable<string>;

/**
 * Преобразовывает дату в виде ISO строки в TuiDate и обратно.
 */
@Injectable({
  providedIn: 'root',
})
class IsoStringToDateTransformer extends TuiValueTransformer<From, To> {
  fromControlValue(controlValue: To): From {
    if (controlValue === null) {
      return controlValue;
    }
    const controlValueAsDate =
      typeof controlValue === 'string' ? new Date(controlValue) : controlValue;

    return TuiDay.fromLocalNativeDate(controlValueAsDate);
  }

  toControlValue(componentValue: From): To {
    return componentValue?.toLocalNativeDate()?.toISOString() || null;
  }
}

@Directive({
  selector: 'tui-textfield[xIsoStringTuiDateTransformer]',
  standalone: true,
  providers: [
    tuiInputDateOptionsProvider(() => ({
      valueTransformer: inject(IsoStringToDateTransformer),
    })),
  ],
})
export class IsoStringTuiDateTransformerDirective {}
